import styled from 'styled-components'

export const AddIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 16px;
  height: 16px;

  svg {
    font-size: 16px;
    fill: var(--On-background-Primary, #fff);
  }
`

export const DropdownMenu = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;

  border-radius: 8px;
  border: 1px solid var(--border-neutral-faded, #dfe2ea);
  background: var(--background-elevation-overlay, #fff);
`

export const DropdownItem = styled.div`
  align-items: center;
  display: flex;

  gap: 8px;
  padding: 8px 12px;
  box-sizing: border-box;
  cursor: pointer;

  color: var(--Foreground-Neutral, var(--Foreground-Neutral, #14171f));

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  width: 100%;

  border-radius: 4px;

  background: var(--background-elevation-base, #fff);

  cursor: pointer;

  :hover {
    background: var(--background-elevation-base, #f3f4f6);
  }
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Section = styled.div`
  flex: 1;
  background: white;
`

export const SectionContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  div label {
    cursor: pointer;
  }
`

export const Item = styled.button`
  border: none;
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  background-color: #f9fafb;

  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);

  transition: background-color 0.2s ease;
  cursor: pointer;
  width: 162px;
  height: 40px;

  &:hover {
    background-color: #f3f4f6;
  }
`
export const ItemLabel = styled.label`
  color: var(--Foreground-Neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  cursor: pointer;
`

export const SectionHeader = styled.div`
  padding: 12px 18px;
  border-bottom: 1px solid #f0f0f0;
`

export const SectionTitle = styled.h2`
  color: var(--Foreground-Neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
  margin: 0;
`
